import { render, staticRenderFns } from "./MercurAttributeSelector.vue?vue&type=template&id=55b7363a&"
import script from "./MercurAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./MercurAttributeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports